/**
 * Slider
 *
 * Modifiers:
 *  --autoplay    autoplay on
 *  --master
 *  --slave             slave sliders sync to master
 *  --fade              fade transition
 *  --sm-1, --md-2      and so on... breakpoints (same as the CSS ones) with number of slides
 */


import { breakpointToPx } from './breakpoints';

/**
 * Classes to slick breakpoints. Use it on the slider, not on the slides.
 *
 * example:
 * slider--md-1 slider--lg-2 slider--xl-3
 *
 */
function classToArrayRegex(el) {
    const regex = /slider--[a-z]{2}-[0-9]{1,2}/g;
    const arr = el.attr('class').match(regex);
    
    if (arr && arr.length > 0) {
        return arr.map((e) => {
            const a = e.replace('slider--', '').split('-');
            a[1] = parseInt(a[1], 10); // the number of slides to display
            return a;
        });
    }
    return false;
}


/**
 * Builds responsive breakpoints for slick
 *
 */
function buildBreakpoints(master) {
    const options = classToArrayRegex(master);
    let breakpoints = [];
    if (options) {
        breakpoints = options.map(option => ({
            breakpoint: breakpointToPx(option[0]),
            settings: { slidesToShow: option[1], slidesToScroll: option[1] },
        }));
    }
    return breakpoints;
}


const initSlider = (sliders = $('.slider__container')) => {
    const baseConfig = {
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        draggable: true,
        swipe: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    
    sliders.each((i, slider) => {
        let config = baseConfig;
        const master = $(slider).find('.slider:not(.slider--slave)').first();
        const prev = $(slider).find('.slider__prev');
        const next = $(slider).find('.slider__next');
        const slaves = $(slider).find('.slider.slider--slave');
        const slides = master.find('.slider__slide').length;

        // if single slide, abort and make the element visible
        if (slides <= 1) return $.merge(master, slaves).css('opacity', 1);
        
        // modifiers
        const autoplay = master.hasClass('slider--autoplay');
        const dots = master.hasClass('slider--dots');
        const responsive = buildBreakpoints(master);
        const masterFade = master.hasClass('slider--fade');
        
        if (slaves.length > 0) {
            slaves.each((j, slave) => {
                const fade = $(slave).hasClass('slider--fade');
                const slaveconfig = {
                    autoplay: false,
                    fade,
                    ...config,
                    draggable: false,
                    swipe: false,
                };
                $(slave).slick(slaveconfig);
            });
            config = { asNavFor: slaves, ...config };
        }
    
        // sync slaves sliders to master
        master.slick({
            autoplay,
            autoplaySpeed: 5000,
            fade: masterFade,
            ...config,
            responsive,
            dots,
        });

        prev.on('click', () => master.slick('slickPrev'));
        next.on('click', () => master.slick('slickNext'));
        $.merge(prev, next).css('display', 'inline-block');
        return true;
    });
};

export default initSlider;
